import type {SketchPointObject} from '../sketch/SketchPointObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图点对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图点协议时返回 true。
 */
export function isSketchPointObject(value: unknown): value is SketchPointObject {
	if (!value || typeof value !== 'object') {
		return false;
	}
	// 仅依赖运行时布尔标记，避免实例链判断带来的耦合。
	return hasRuntimeFlag(value, 'isSketchPointObject');
}
